import React from "react";
import styles from "./PressReleaseCard.module.scss";
import * as DateIso from "@tiicker/util/lib/date-iso";
import Button from "components/core/Button/Button";

type Props = {
  title: string;
  date: Date;
  slug: string;
};

const PressReleaseCard = (props: Props) => {
  const date = DateIso.toIsoDate(props.date);

  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <h5 className={styles.title}>{props.title}</h5>
      </div>
      <div className={styles.buttonContainer}>
        <p className={styles.date}>{DateIso.formatLongMonthDayYear(date)}</p>
        <Button type="inline" arrow href={`/news/${props.slug}`}>
          Read Article
        </Button>
      </div>
    </div>
  );
};

export default PressReleaseCard;
